import axios from "axios";

// import iconv from "iconv-lite";
// import { history } from "../App";

/** base url to make requests to the the movie database */
const instance = axios.create({
 // baseURL: "http://localhost:8080/damcloudtaservice/rest/meta",
   //baseURL: "/damcloudtaservice/rest/meta",
  //baseURL: "https://api.themoviedb.org/3"
 // baseURL: "http://15.237.23.231:8020/damcloudtaservice/rest/meta",
 // baseURL: "https://tncdigital.cat/damcloudservicetnctest/rest/meta",
  baseURL: "https://tncdigital.cat/damcloudservicetnceducativo/rest/meta",
});

instance.interceptors.request.use(
  (req) => {
    req.headers.authorization = "Bearer " + localStorage.getItem("ta-jwt");
    return req;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    if (config.headers["refresh-token"]) {
      localStorage.setItem("ta-jwt", config.headers["refresh-token"]);
    }
    return config;
  },
  (error) => {
    console.log(error.response);
    if (error.response?.status === 401) {
      console.log("401");
      // history.push('/login');
    }
    return Promise.reject(error);
  }
);

export default instance;
